import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import arrowHovered from "../../Icons/arrowHovered.svg";
import { useGetDashBoardReviewsQuery } from "../../api/allReviewsAPI";
import { useDispatch, useSelector } from "react-redux";
import { setDashBoardReviewData } from "../../store/reducers/dashboardReviewsSlice";
import timesheet from "../../Icons/Timesheet.svg";
import reviewIcon from "../../Icons/review-file.svg";
import reviewRegularizationIcon from '../../Icons/reviewRegularizationIcon.svg'

const ReviewCard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data: allReviewData, isSuccess } = useGetDashBoardReviewsQuery(
    {},
    { refetchOnMountOrArgChange: true }
  );
  const dashBoardReviewData = useSelector((state) => state.dashBoardReview);
  const handleArrowClick = () => {
    navigate("/allReview");
  };
  const getCount = () => {
    let count = 0;
    if (isSuccess) {
      dashBoardReviewData?.pendingleaves[0] && count++;
      dashBoardReviewData?.pendingtimesheets[0] && count++;
      dashBoardReviewData?.regularizations[0] && count++;
    }
    return count;
  };
  useEffect(() => {
    if (isSuccess) {
      dispatch(setDashBoardReviewData(allReviewData.data));
    }
  }, [allReviewData, isSuccess]);

  return (
    <div className="max-w-sm mx-auto my-8 bg-white shadow-lg rounded-lg overflow-hidden border border-gray-200 p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-gray-800">Review</h2>
        <button
          onClick={() => handleArrowClick()}
          className="text-gray-500 hover:text-gray-800 transition duration-300 w-16 h-9"
        >
          <img src={arrowHovered} alt="arrowHovered" />
        </button>
      </div>
      <div className="m-2 flex flex-col gap-4 font-medium">
        <div className="font-extrabold text-5xl">{getCount()}</div>
        <div>Things to Review</div>
      </div>
      <div className="grid grid-cols-3 font-medium">
        {dashBoardReviewData?.pendingtimesheets[0] && (
          <div className="bg-blue-200 p-5 m-1 rounded-md">
            <img
              src={timesheet}
              className="w-[2.5rem] font-extrabold m-1"
              alt="timeSheetIcon"
            />
            Time Sheets
          </div>
        )}
        {dashBoardReviewData?.pendingleaves[0] && (
          <div className="bg-blue-200 p-5 m-1 rounded-md">
            <img src={reviewIcon} className="w-[3rem]" alt="reviewIcon" />
            Pending Leaves
          </div>
        )}
        {dashBoardReviewData?.regularizations[0] && (
          <div className="bg-blue-200 p-5 m-1 rounded-md overflow-hidden">
            <img
              src={reviewRegularizationIcon}
              className="w-[3rem]"
              alt="regularizationIcon"
            />
            <div className="break-words">Regularization</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewCard;
